import { Pipe, PipeTransform } from '@angular/core';
import { CUSTOMFIELD_TYPE_IDS } from '../constants/typeId';
@Pipe({ name: 'massEditAvailableFields', pure: false })
export class MassEditAvailableFieldsPipe implements PipeTransform {

    transform(availableFields: Array<any>, selectedField: any, otherSelectedFields: Array<any>): any {
        if (availableFields && availableFields.length && otherSelectedFields) {

            const otherFields: string[] = otherSelectedFields.filter(f=> f.selectedField?.field && f.selectedField?.field!=selectedField?.field).map(fieldDetails=> fieldDetails.selectedField.field)

            return availableFields.filter(obj => !otherFields.includes(obj.field) || [CUSTOMFIELD_TYPE_IDS.MULTISELECT,CUSTOMFIELD_TYPE_IDS.CHECKBOX].includes(obj?.formControlId));
        } else {
            return availableFields
        }
    }

}
